export const BRAND = {
  name: "ATL Esquadrias",
  tagline: "Soluções em Alumínio e Vidro",
  hero_title: "Esquadrias que valorizam seu projeto.",
  whatsapp_raw: "554898025799",
  whatsapp_display: "(48) 9802-5799",
  instagram_handle: "@atlaluminio",
  instagram_url: "https://instagram.com/atlaluminio",
  logo_url:
    "https://customer-assets.emergentagent.com/job_c9fd6220-95dd-4cf5-b2a2-aebce091ed46/artifacts/n1vci2ug_Captura_de_Tela_2026-06-17_a%CC%80s_05.52.10-removebg-preview.png",
  region: "Florianópolis e Região",
};

export const waLink = (message) => {
  const text = encodeURIComponent(
    message ||
      "Olá! Vim pelo site da ATL Esquadrias e gostaria de solicitar um orçamento."
  );
  return `https://wa.me/${BRAND.whatsapp_raw}?text=${text}`;
};

export const NAV = [
  { label: "Início", href: "#inicio" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Serviços", href: "#servicos" },
  { label: "Processo", href: "#processo" },
  { label: "Projetos", href: "#projetos" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Contato", href: "#contato" },
];

export const HERO_BULLETS = [
  "Fabricação Própria",
  "Instalação Especializada",
  "Garantia de Qualidade",
  "Atendimento em Florianópolis e Região",
];

export const DIFFERENTIATORS = [
  {
    n: "01",
    title: "Fabricação Própria",
    desc: "Controle total da qualidade em cada etapa da produção, do corte do alumínio ao acabamento final.",
  },
  {
    n: "02",
    title: "Equipe Especializada",
    desc: "Profissionais experientes, altamente qualificados e treinados para entregas de alto padrão em Florianópolis e região.",
  },
  {
    n: "03",
    title: "Atendimento Rápido",
    desc: "Respondemos seu WhatsApp em minutos. Agilidade do primeiro contato até a entrega final.",
  },
  {
    n: "04",
    title: "Materiais de Primeira Linha",
    desc: "Alumínio reforçado e vidros de alta resistência. Durabilidade e estética que duram décadas.",
  },
  {
    n: "05",
    title: "Projetos Sob Medida",
    desc: "Cada projeto é desenvolvido conforme a necessidade, o estilo e as medidas do seu ambiente.",
  },
  {
    n: "06",
    title: "Garantia Pós-Instalação",
    desc: "Compromisso após a entrega — assistência técnica e suporte para você ficar tranquilo.",
  },
];

export const SERVICES = [
  { title: "Janelas de Alumínio", desc: "Linhas Suprema, Modular e Sob Medida." },
  { title: "Portas de Alumínio", desc: "De abrir, correr, balcão e camarão." },
  { title: "Portões", desc: "Sociais, basculantes e de garagem." },
  { title: "Box para Banheiro", desc: "Vidro temperado incolor, fumê e jateado." },
  { title: "Sacadas", desc: "Envidraçamento total ou parcial." },
  { title: "Fechamentos de Fachadas", desc: "Pele de vidro, structural glazing." },
  { title: "Coberturas em Vidro e Policarbonato", desc: "Pergolados, áreas externas e claraboias." },
  { title: "Manutenção", desc: "Reparo, regulagem e troca de componentes." },
];

export const QUALITY_BULLETS = [
  "Fabricação Própria",
  "Instalação Profissional",
  "Orçamento Sem Compromisso",
  "Acabamento Premium",
  "Garantia de Qualidade",
  "Atendimento em Florianópolis e Região",
];

export const PROCESS = [
  {
    n: "01",
    title: "Você envia as medidas",
    desc: "Pelo WhatsApp, você nos envia as medidas e fotos do ambiente — Florianópolis, São José, Palhoça, Biguaçu e região.",
  },
  {
    n: "02",
    title: "Prévia de orçamento",
    desc: "Elaboramos uma prévia de orçamento com base nas medidas enviadas, de forma rápida e transparente.",
  },
  {
    n: "03",
    title: "Medição técnica no local",
    desc: "Realizamos a medição técnica no local para alinhar todos os detalhes do projeto sob medida.",
  },
  {
    n: "04",
    title: "Fabricamos",
    desc: "Cada peça é fabricada na nossa fábrica própria, com alumínio reforçado e vidros de alta resistência.",
  },
  {
    n: "05",
    title: "Instalamos",
    desc: "Nossa equipe especializada executa a instalação com total segurança e profissionalismo.",
  },
  {
    n: "06",
    title: "Entregamos com garantia",
    desc: "Projeto entregue com acabamento premium e garantia pós-instalação — você fica tranquilo.",
  },
];

// Project images: real photos provided by the client.
export const PROJECTS = [
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/knj5sdd7_WhatsApp%20Image%202026-06-14%20at%2007.07.36%20%285%29.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/4udu4s4q_WhatsApp%20Image%202026-06-14%20at%2007.07.41%20%281%29.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/4rzcmnwo_WhatsApp%20Image%202026-06-14%20at%2007.07.34%20%281%29.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/9d6sukka_WhatsApp%20Image%202026-06-14%20at%2007.07.34%20%282%29.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/nsrtp3mg_WhatsApp%20Image%202026-06-14%20at%2007.07.32%20%283%29.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/gv9vh605_WhatsApp%20Image%202026-06-14%20at%2007.07.33%20%281%29.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/dlbd9led_WhatsApp%20Image%202026-06-14%20at%2007.07.33%20%282%29.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/ev6kvjp0_WhatsApp%20Image%202026-06-14%20at%2007.07.35%20%281%29.jpeg",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_aluminio-vidro/artifacts/pnlrp9h2_WhatsApp%20Image%202026-06-14%20at%2007.07.40%20%282%29.jpeg",
  },
];

export const TESTIMONIALS = [
  {
    name: "Carlos Henrique",
    city: "Florianópolis/SC",
    rating: 5,
    quote:
      "Excelente atendimento do início ao fim. As esquadrias ficaram perfeitas, com acabamento impecável. Recomendo sem pensar duas vezes.",
  },
  {
    name: "Mariana Souza",
    city: "São José/SC",
    rating: 5,
    quote:
      "Fechamos nossa sacada com a ATL Esquadrias e o resultado ficou maravilhoso. Equipe organizada, pontual e muito profissional.",
  },
  {
    name: "Roberto Martins",
    city: "Palhoça/SC",
    rating: 5,
    quote:
      "Qualidade acima das expectativas. Materiais de primeira linha e instalação extremamente cuidadosa.",
  },
  {
    name: "Fernanda Oliveira",
    city: "Florianópolis/SC",
    rating: 5,
    quote:
      "Minha residência ganhou outra aparência depois da instalação das portas e janelas. Atendimento excelente e serviço impecável.",
  },
];

export const STATS = [
  { icon: "🏗️", value: "+500", label: "Obras Entregues" },
  { icon: "🤝", value: "+400", label: "Clientes Atendidos" },
  { icon: "⭐", value: "5 anos", label: "de Experiência" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2560&auto=format&fit=crop";
